// 通知模块上下文

import { createContext, useContext, ReactNode } from "react";
import { useNotificationStore } from "../stores";
import { useBaseCache } from "../../base/contexts";

// Context类型定义
interface NotificationContextType {
  // 通知Store（包含所有状态和方法）
  notificationStore: ReturnType<typeof useNotificationStore>;
  // 基础缓存
  cache: ReturnType<typeof useBaseCache>;
}

// 创建Context
const NotificationContext = createContext<NotificationContextType | null>(null);

// Provider Props
interface NotificationContextProviderProps {
  children: ReactNode;
}

// Provider组件
export function NotificationContextProvider({
  children,
}: NotificationContextProviderProps) {
  const notificationStore = useNotificationStore();
  const cache = useBaseCache();

  const value: NotificationContextType = {
    notificationStore,
    cache,
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
}

// Hook
export function useNotificationContext(): NotificationContextType {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotificationContext must be used within NotificationContextProvider"
    );
  }
  return context;
}
